import { styled } from '@linaria/react';

import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';

export const WorkingArea = styled.div`
	width: 100%;
	max-width: 750px;
	padding-right: 12px;
	padding-left: 12px;
	margin-right: auto;
	margin-left: auto;
`;

export const CloseButton = styled(ButtonIconGhost)`
	position: absolute;
	top: 1rem;
	right: 1rem;
`;
